import React from 'react';

import ImageUpload from 'components/ImageUpload';
import styled from 'styled-components';
import { baseTheme } from 'themes/clients/baseTheme';

import { Gif, PhotoComment } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

const PhotoIcon = () => <PhotoComment fill="transparent" boxSize="24px" />;

const GifIcon = () => <Gif fill="transparent" boxSize="24px" />;

export default function UploadTypesView({
  className,
  uploadFile,
  toggleGifModal,
  gifUrl,
  uploadedImage,
  EmojiSelect, // emojiPlugin.EmojiSelect component from draft js
  iconSize = '40px',
}) {
  return (
    <Container className={className || ''}>
      {EmojiSelect && <EmojiSelect closeOnEmojiSelect />}

      <Button
        disabled={Boolean(uploadedImage)}
        onClick={toggleGifModal}
        sx={{
          svg: {
            color: `${baseTheme.colors.text.g2} !important`,
          },
        }}
        variant="tertiary"
        StartIcon={GifIcon}
        height={iconSize}
      />
      <ImageUpload
        disabled={Boolean(gifUrl)}
        icon={
          <Button
            sx={{
              svg: {
                color: `${baseTheme.colors.text.g2} !important`,
              },
            }}
            variant="tertiary"
            StartIcon={PhotoIcon}
            disabled={Boolean(gifUrl)}
            height={iconSize}
          />
        }
        setFile={uploadFile}
      />
    </Container>
  );
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
`;
